import api, { withLoading } from '@/api/api';

const resource = `v1/ict/usuarios`;
const LOADING_KEY = 'ict-usuarios';

export default {
    selecao(empresaId, params = {}) {
        const { query } = params;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/selecao${query ? `?${query}` : ""}`).then(res => res.data)
        );
    },
}
